// extracted by mini-css-extract-plugin
export var changeIcon = "_4f-4";
export var container = "_4f-0";
export var divider = "_4f-7";
export var externalLinkIcon = "_4f-1";
export var green = "_4f-5";
export var helpCircleIcon = "_4f-3";
export var iconButton = "_4f-2";
export var red = "_4f-6";